import { operatingCountrySelector } from "../../../../web/src/store/auth/selectors";

export { operatingCountrySelector }

export const selectors = {
  operatingCountrySelector,
}
